import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cart: []
}

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            state.cart.push(action.payload)
        },
        removeFromCart: (state, action) => {
            const id = action.payload
            state.cart = state.cart.filter((item) => item.id !== id)
        },
        deleteAllCart: (state, action) => {
            state.cart = []
        }
    }
})

export const { addToCart, removeFromCart, deleteAllCart } = cartSlice.actions
export const getCartNumber = (state) => state.cart.cart.length
export const getCartList = (state) => state.cart.cart

export default cartSlice.reducer